<template>
  <div class="scene" ref="scene"
    @touchstart="touchstart"
    @touchmove.prevent="touchmove"
    @touchend="touchend">
    <!-- 滑动提示 -->
    <transition name="fade">
      <div class="scene__hint" v-show="hint.show" :style="currentScene === 's2' ? 'top: 110vw;right:3%;' : 'bottom: 12%;'">
        <img src="@/assets/imgs/scene/swipe-text.png" class="scene__hint__text">
        <div class="scene__hint__line">
          <img src="@/assets/imgs/scene/swipe-line.png">
        </div>
        <img src="@/assets/imgs/scene/swipe-hand.png" class="scene__hint__hand">
      </div>
    </transition>
    <!-- 场景一 -->
    <transition name="fade">
      <div class="scene__result">
        <div class="s1" v-show="currentScene === 's1'">
          <img src="https://static.shikehuyu.com/ddyc/res/imgs/scene1_bg.png" class="s1__bg">
          <img src="@/assets/imgs/scene/s1/text.png" class="s1__text animated fadeIn" v-show="result.show">
          <img src="@/assets/imgs/scene/s1/smoke1.png" class="s1__smoke1 wanderHoz">
          <img src="@/assets/imgs/scene/s1/smoke2.png" class="s1__smoke2 wanderHoz">
          <img src="@/assets/imgs/scene/s1/hand1.png" class="s1__hand1 rotate2">
          <img src="@/assets/imgs/scene/s1/hand3.png" class="s1__hand3 rotate3">
          <img src="@/assets/imgs/scene/s1/hand2.png" class="s1__hand2 float1">
          <img src="https://static.shikehuyu.com/ddyc/res/imgs/scene1_bottomv3.png" class="s1__bottom" :style="bottomStyle">
        </div>
        <div class="s2" v-show="currentScene === 's2'">
          <img src="https://static.shikehuyu.com/ddyc/res/imgs/scene2_bg.png" class="s2__bg">
          <img src="https://static.shikehuyu.com/ddyc/res/imgs/scene2_light.png" class="s2__light bling2">
          <img src="@/assets/imgs/scene/s2/text.png" class="s2__text animated fadeIn" v-show="result.show">
          <img src="@/assets/imgs/scene/s2/chat.png" class="s2__chat animated fadeInUp" v-show="result.show">
          <img src="@/assets/imgs/scene/s2/hand.png" class="s2__hand rotate4">
          <img src="https://static.shikehuyu.com/ddyc/res/imgs/scene2_bottomv3.png" class="s2__bottom" :style="bottomStyle">
        </div>
        <div class="s3" v-show="currentScene === 's3'">
          <div :style="s3BgStyle">
            <img src="https://static.shikehuyu.com/ddyc/res/imgs/scene3_bgv2.png" class="s3__bg">
            <img src="@/assets/imgs/scene/s3/flo.png" class="s3__flo" :class="result.show ? 'rotate5' : ''">
            <img src="@/assets/imgs/scene/s3/flower.png" class="s3__flower animated fadeInDown" v-show="result.show">
            <img src="@/assets/imgs/scene/s3/light.png" class="s3__light bling2">
            <img src="@/assets/imgs/scene/s3/chat1.png" class="s3__chat1 animated fadeInUp" v-show="result.show">
            <img src="@/assets/imgs/scene/s3/chat2.png" class="s3__chat2 animated fadeInUp" v-show="result.show">
            <img src="@/assets/imgs/scene/s3/text.png" class="s3__text animated fadeIn" v-show="result.show">
          </div>
          <img src="https://static.shikehuyu.com/ddyc/res/imgs/scene3_bottomv3.png" class="s3__bottom" :style="bottomStyle">
        </div>
        <div class="scene__result__btns">
          <img src="@/assets/imgs/scene/btn-next.png" class="scene__result__btns__1" @click="next" v-show="currentScene === 's1' || currentScene === 's2'">
          <img src="@/assets/imgs/scene/btn-end.png" class="scene__result__btns__1" @click="next" v-show="currentScene === 's3'">
          <img src="@/assets/imgs/scene/btn-action.png" class="scene__result__btns__2" @click="$emit('action')">
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import * as PIXI from 'pixi.js'
import sprites from '@/assets/data/sprites'
import scenes from '@/assets/data/scenes'
import animations from '@/assets/data/animations'
import { TweenMax, TimelineMax } from 'gsap'

export default {
  data() {
    return {
      hint: { show: false },
      result: { show: false },
      currentScene: 's1'
    }
  },
  computed: {
    bottomStyle() {
      const ww = window.innerWidth
      const wh = window.innerHeight
      const ratio = ww / wh
      const y = ((ratio / (640 / 1302)) - 1) * 40
      return `transform: translate(0, ${y}%);`
    },
    s3BgStyle() {
      const ww = window.innerWidth
      const wh = window.innerHeight
      const ratio = ww / wh
      const y = -((ratio / (640 / 1302)) - 1) * 30
      return `transform: translate(0, ${y}%);`
    }
  },
  methods: {
    init() {
      this.width = window.innerWidth
      this.height = window.innerHeight
      this.hr = window.innerHeight * 0.05
      this.clearPoints = []
      this.sprites = {}
      this.timelines = {}
      this.groups = {}
      this.swipeEnabled = false
      this.clearPoints = []
      this.clearPointsCount = 0
      this.clearing = false
      // 初始化应用
      this.app = new PIXI.Application({
        resolution: 2,
        transparent: true,
        width: this.width,
        height: this.height,
        forceCanvas: true
      })
      // 加入场景
      this.canvas = this.app.view
      this.ctx = this.canvas.getContext('2d')
      this.$refs.scene.appendChild(this.canvas)
      this.app.renderer.on('postrender', this.onRender)
      // 开始加载
      this.load()
    },
    load() {
      PIXI.loader
        .add(sprites)
        .on('progress', this.loadProgress.bind(this))
        .load(this.loadDone.bind(this))
    },
    loadProgress(loader) {
      this.$bus.$emit('loadProgress', loader.progress)
    },
    loadDone() {
      this.initSprites()
      this.initTimeline()
      this.$bus.$emit('loadDone')
    },
    start() {
      this.timelines.s1.play()
      // this.timelines.g_s1_h.play()
      // this.groups.s1.alpha = 0
      // this.groups.s2.alpha = 0
      // this.groups.s3.alpha = 0
      // this.timelines.g_s2_s.play()
      // this.result.show = true
      // this.timelines.g_s3_s.play()
    },
    initSprites() {
      Object.keys(scenes).forEach((scene) => {
        this.groups[scene] = new PIXI.Container()
        this.timelines[`g_${scene}_h`] = new TimelineMax({ paused: true })
        this.setAnimation(this.groups[scene], [{
          delay: 0,
          from: { alpha: 1 },
          to: { alpha: 0 },
          duration: 1,
          onComplete: function() {
            if (this.currentScene === 's1') {
              this.$bus.playMusic('hotpot')
              // this.$bus.musicFadeIn('crowd', 0, 1, 300)
              // this.$bus.playMusic('crowd')
              // setTimeout(() => {
              //   this.$bus.musicFadeOut('crowd', 1, 0, 300)
              // }, 700)
              setTimeout(() => {
                this.$bus.playMusic('cheer')
              }, 500)
              setTimeout(() => {
                this.$bus.playMusic('cheer')
                this.$bus.musicFadeOut('hotpot')
                this.$bus.musicFadeOut('hotpot2')
              }, 3000)
              this.$bus.randomPlayMusic('hotpot', 800, 1000)
              this.$bus.randomPlayMusic('hotpot2', 600, 800)
            } else if (this.currentScene === 's2') {
              setTimeout(() => {
                this.$bus.playMusic('cry2')
              }, 1200)
            } else if (this.currentScene === 's3') {
              this.$bus.playMusic('car')
            }
            this.clearSceneDone()
          }
        }], `g_${scene}_h`)
        if (scene !== 's1') {
          this.timelines[`g_${scene}_s`] = new TimelineMax({ paused: true })
          this.setAnimation(this.groups[scene], [{
            delay: 0,
            from: { alpha: 0 },
            to: { alpha: 1 },
            duration: 1,
            onComplete: function() {
              this.showSceneDone()
            }
          }], `g_${scene}_s`)
        }
        Object.keys(scenes[scene]).forEach((key) => {
          // 创建
          const options = scenes[scene][key]
          const sprite = new PIXI.Sprite(PIXI.loader.resources[options.key || key].texture)
          // 设置属性
          this.setSize(sprite, options.size)
          this.setAnchor(sprite, options.anchor)
          this.setPosition(sprite, options.position)
          // 加入场景
          this.groups[scene].addChild(sprite)
          this.app.stage.addChild(this.groups[scene])
          this.sprites[key] = sprite
        })
      })
    },
    initTimeline() {
      Object.keys(animations).forEach((scene) => {
        this.timelines[scene] = new TimelineMax({ paused: true })
        Object.keys(animations[scene]).forEach((key) => {
          this.setAnimation(this.sprites[key], animations[scene][key], scene)
        })
      })
    },
    sceneComplete() {
      this.swipeEnabled = true
      this.hint.show = true
      this.clearPoints = []
      this.clearPointsCount = 0
      if (this.currentScene === 's3') {
        this.$bus.musicFadeIn('typing2')
      }
    },
    getNextScene() {
      const list = ['s1', 's2', 's3']
      const nextIndex = list.indexOf(this.currentScene) + 1
      return nextIndex > 2 ? null : list[nextIndex]
    },
    next() {
      const next = this.getNextScene()
      if (next) { // 完结
        if (this.currentScene === 's1') {
          this.$bus.clearRandomTimeout('hotpot')
          this.$bus.clearRandomTimeout('hotpot2')
        } else if (this.currentScene === 's2') {
          this.$bus.musicFadeIn('typing2')
        }
        this.timelines[`g_${next}_s`].play()
      } else {
        this.$emit('skip')
      }
    },
    showSceneDone() {
      this.currentScene = this.getNextScene()
      this.timelines[this.currentScene].play()
      this.result.show = false
    },

    // 擦除相关
    clearScene() {
      if (!this.clearing) {
        this.clearing = true
        this.timelines[`g_${this.currentScene}_h`].play()
      }
    },
    clearSceneDone() {
      this.clearing = false
      this.swipeEnabled = false
      this.hint.show = false
      this.result.show = true
      this.canvas.style.pointerEvents = 'none'
    },
    touchstart(e) {
      if (this.swipeEnabled) {
        this.hint.show = false
        this.clearPoints.push([])
        const x = e.touches[0].clientX
        const y = e.touches[0].clientY
        this.addPoint(x, y)
      }
    },
    touchmove(e) {
      if (this.swipeEnabled) {
        const x = e.touches[0].clientX
        const y = e.touches[0].clientY
        const dx = Math.abs(x - this.lastX)
        const dy = Math.abs(y - this.lastY)
        if (dx > this.hr / 5 || dy > this.hr / 5) this.addPoint(x, y)
      }
    },
    touchend() {},
    addPoint(x, y) {
      if (x >= 0 && x <= this.width && y >= 0 && y <= this.height) {
        this.lastX = x
        this.lastY = y
        if (this.clearPoints.length < 1) this.clearPoints.push([])
        this.clearPoints[this.clearPoints.length - 1].push({ x, y })
        if (++this.clearPointsCount > 70) {
          this.clearScene()
        }
      }
    },
    onRender() {
      if (this.swipeEnabled && this.clearPoints.length > 0) {
        const tmpShadowBlur = this.ctx.shadowBlur
        const tmpShadowColor = this.ctx.shadowColor
        this.ctx.globalCompositeOperation = 'destination-out'; 
        this.ctx.fillStyle = '#000000'
        this.ctx.shadowBlur = this.hr;
        this.ctx.shadowColor = "black";
        this.ctx.lineCap = 'round'
        this.ctx.lineWidth = this.hr * 4
        this.ctx.beginPath();
        this.clearPoints.forEach((list) => {
          const start = list[0]
          this.ctx.moveTo(start.x * 2, start.y * 2)
          list.forEach(({ x, y }) => {
            this.ctx.lineTo(x * 2, y * 2)
          })
        })
        this.ctx.stroke();
        this.ctx.shadowBlur = tmpShadowBlur
        this.ctx.shadowColor = tmpShadowColor
      }
    },

    // ────────────────────────────────────────────────────────────────────────────────
    // 通用属性设置
    // ────────────────────────────────────────────────────────────────────────────────
    // 设置尺寸
    setSize (obj, size) {
      if (size.mode === 'cover') { // 覆盖
        const ratio = obj.width / obj.height
        const screenRatio = this.width / this.height
        if (ratio > screenRatio) { // 更宽
          const scale = this.app.screen.height / obj.height
          obj.scale.x = scale
          obj.scale.y = scale
        } else {
          const scale = this.app.screen.width / obj.width
          obj.scale.x = scale
          obj.scale.y = scale
        }
      } else if (size.mode === 'widthFit') { // 按宽度适应
        const scale = this.app.screen.width * size.width / obj.width
        obj.scale.x = scale
        obj.scale.y = scale
      } else if (size.mode === 'heightFit') { // 按高度适应
        const scale = this.app.screen.height * size.height / obj.height
        obj.scale.x = scale
        obj.scale.y = scale
      } else { // 自定义
        obj.width = size.width
        obj.height = size.height
      }
    },

    // 设置锚点
    setAnchor (obj, anchor) {
      if (typeof anchor === 'string') {
        const anchorMap = this.positionMap(anchor)
        obj.anchor.x = anchorMap.x
        obj.anchor.y = anchorMap.y
      } else {
        obj.anchor.x = anchor.x
        obj.anchor.y = anchor.y
      }
    },

    // 设置位置
    setPosition (obj, position) {
      if (typeof position === 'string') {
        position = this.positionMap(position)
      }
      obj.position.x = position.x * this.app.screen.width
      obj.position.y = position.y * this.app.screen.height
    },

    // 位置转换
    positionMap (type) {
      const map = {
        top: { x: 0.5, y: 0 },
        right: { x: 1, y: 0.5 },
        bottom: { x: 0.5, y: 1 },
        left: { x: 0, y: 0.5 },
        topLeft: { x: 0, y: 0 },
        topRight: { x: 1, y: 0 },
        bottomLeft: { x: 0, y: 1 },
        bottomRight: { x: 1, y: 1 },
        center: { x: 0.5, y: 0.5 }
      }
      return map[type] || { x: 0, y: 0 }
    },

    // 动画对象
    setAnimation (obj, animations, scene) {
      if (obj && animations && animations instanceof Array) {
        animations.forEach(({ from, to, yoyo = false, repeat = 0, delay = 0, duration = 1, onComplete, onStart }) => {
          // if (!to.ease || (to.ease && to.ease !== 'ease')) to.ease = Linear.easeNone
          let action
          if (from && to) {
            action = TweenMax.fromTo(obj, duration, from, to)
          } else if (to) {
            action = TweenMax.to(obj, duration, to)
          } else if (from) {
            action = TweenMax.from(obj, duration, from)
          }
          const options = { yoyo, repeat }
          if (onStart) options.onStart = onStart.bind(this)
          if (onComplete) options.onComplete = onComplete.bind(this)
          const timeline = new TimelineMax(options)
          timeline.add(action)
          this.timelines[scene].add(timeline, delay)
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@/style/mixin.scss';

@keyframes hintLine {
  from {
    height: 0;
  }
  to {
    height: 100%;
  }
}

@keyframes hintHand {
  from {
    transform: rotate(-40deg);
  }
  to {
    transform: rotate(30deg);
  }
}

.scene {
  @include fullscreen;
  canvas {
    @include fullscreen;
    z-index: 2;
  }
  &__hint {
    position: absolute;
    right: 3%;
    // bottom: 12%;
    width: 26vw;
    height: 26vw;
    z-index: 3;
    &__text {
      width: 80%;
      position: absolute;
      top: -16%;
      left: -16%;
    }
    &__line {
      animation-name: hintLine;
      animation-duration: 2s;
      // animation-iteration-count: infinite;
      // animation-direction: alternate;
      height: 100%;
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      overflow: hidden;
      img {
        display: block;
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    &__hand {
      animation-name: hintHand;
      animation-duration: 2s;
      animation-iteration-count: 3;
      animation-timing-function: ease-out;
      animation-direction: alternate;
      animation-fill-mode: forwards;
      width: 28%;
      position: absolute;
      bottom: 32%;
      right: 30%;
      transform-origin: 280% 300%;
    }
  }
  &__result {
    @include fullscreen;
    z-index: 1;
    &__btns {
      z-index: 2;
      position: absolute;
      left: 50%;
      margin-left: -2.65rem;
      bottom: 6vh;
      width: 5.3rem;
      font-size: 0;
      img {
        width: 2.45rem;
      }
      &__1 {
        margin-right: .4rem;
      }
    }
  }
}

.s1 {
  @include fullscreen;
  z-index: 1;
  &__bg {
    position: absolute;
    width: 100vw;
    top: 0;
    left: 0;
  }
  &__text {
    position: absolute;
    top: 6vh;
    left: 9vw;
    width: 4.34rem;
    animation-duration: 3s !important;
  }
  &__bottom {
    position: absolute;
    width: 100vw;
    bottom: 0;
    left: 0;
  }
  &__smoke1 {
    position: absolute;
    top: 6.4rem;
    right: 0;
    width: 5.9rem;
  }
  &__smoke2 {
    position: absolute;
    top: 4.8rem;
    right: 0;
    width: 6.27rem;
    opacity: .5;
    animation-duration: 1.2s !important;
  }
  &__hand1 {
    position: absolute;
    top: 3.54rem;
    left: -.1rem;
    width: 1.78rem;
    transform-origin: 0% 80%;
  }
  &__hand2 {
    position: absolute;
    top: 6.15rem;
    right: 0;
    width: 5.71rem;
  }
  &__hand3 {
    position: absolute;
    top: 4.43rem;
    right: -.1rem;
    width: 2.3rem;
    transform-origin: 100% 70%;
  }
}

.s2 {
  @include fullscreen;
  z-index: 1;
  &__bg {
    position: absolute;
    width: 100vw;
    top: 0;
    left: 0;
  }
  &__text {
    position: absolute;
    top: 6vh;
    left: 9vw;
    width: 2.75rem;
    animation-duration: 2s !important;
    animation-delay: 1.5s;
  }
  &__light {
    position: absolute;
    top: 0;
    right: -2vw;
    width: 120vw;
  }
  &__chat {
    position: absolute;
    top: 55vw;
    right: 3vw;
    width: 2.59rem;
    animation-duration: .5s !important;
  }
  &__hand {
    position: absolute;
    top: 81vw;
    right: 8.5vw;
    width: .3rem;
    transform-origin: 0% 98%;
  }
  &__bottom {
    position: absolute;
    width: 100vw;
    bottom: 0;
    left: 0;
  }
}

.s3 {
  @include fullscreen;
  z-index: 1;
  div {
    @include fullscreen;
  }
  &__bg {
    position: absolute;
    width: 100vw;
    top: 0;
    left: 0;
  }
  &__light {
    position: absolute;
    top: 7vw;
    right: -1vw;
    width: 6.5rem;
  }
  &__text {
    position: absolute;
    top: 28vw;
    right: 3vw;
    width: 2.61rem;
    animation-duration: 2s !important;
    animation-delay: 3s;
  }
  &__chat1 {
    position: absolute;
    top: 73vw;
    left: 12vw;
    width: 2.17rem;
    animation-duration: .5s !important;
  }
  &__chat2 {
    position: absolute;
    top: 67vw;
    right: 3vw;
    width: 1.18rem;
    animation-duration: .5s !important;
    animation-delay: 2s;
  }
  &__flower {
    position: absolute;
    top: 78vw;
    right: 6vw;
    width: 1.82rem;
    animation-delay: 2.2s;
  }
  &__flo {
    position: absolute;
    top: 73vw;
    right: 16vw;
    width: 1.09rem;
    animation-delay: 2s;
  }
  &__bottom {
    position: absolute;
    width: 100vw;
    bottom: 0;
    left: 0;
  }
}
</style>